import { ArrowBackIos, ArrowForwardIos, CloudDownloadRounded, ZoomIn } from '@mui/icons-material';
import { Box, Button, Dialog, DialogContent, IconButton, Paper, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { IMAGES_HOST } from '../config/config';
import { BRANDING } from '../config/branding';

const resolveImageUrl = (src) => {
  if (!src) return src;
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  return `${IMAGES_HOST}/IA/${src}.jpg`;
};

const Banner = ({ images, tittle, height = 200, onlyImages = false, auto = true, onImageChange }) => {
  //const classes = useStyles();
  const [open, setOpen] = useState(false);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Función para avanzar a la siguiente imagen
  const nextImage = useCallback(() => {
    if (!images || images.length === 0) return;
    setCurrentImageIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % images.length;
      onImageChange && onImageChange(nextIndex);
      return nextIndex;
    });
  }, [images, onImageChange]);

  // Función para retroceder a la imagen anterior
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Efecto para cambiar la imagen automáticamente cada 5 segundos (por ejemplo), solo si hay más de una imagen.
  useEffect(() => {
    if (auto && images && images.length > 1) {
      const interval = setInterval(() => {
        nextImage();
      }, 5000); // Cambia la imagen cada 5 segundos

      // Limpiar el intervalo al desmontar el componente o cuando cambien las imágenes
      return () => clearInterval(interval);
    }
  }, [auto, images, nextImage]);

  // Función para cambiar automáticamente la imagen cada cierto tiempo
  // React.useEffect(() => {
  //   const interval = setInterval(nextImage, delay);
  //   return () => clearInterval(interval);
  // }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleDownload = () => {
    if (images && images.length > 0) {
      const image = images[currentImageIndex];
      const resolved = resolveImageUrl(image);
      const aux = resolved?.split('/');
      const fileName = aux[aux.length - 1];

      const link = document.createElement('a');
      link.href = resolved;
      link.setAttribute('download', fileName);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Paper variant='outlined' sx={{ 
      position: 'relative', 
      height: height,
      width: '100%',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Box height='100%' width='100%' alignContent='center' display='flex'>
        <img 
          src={images && images[currentImageIndex] !== "" ? resolveImageUrl(images[currentImageIndex]) : BRANDING.logoUrl} 
          alt={`Imagen ${currentImageIndex + 1}`} 
          style={{ 
            height: '100%', 
            width: '100%', 
            objectFit: 'cover', 
            alignContent: 'center'
          }} 
        />
      </Box>

      {images && images.length > 1 && <Button onClick={prevImage} sx={{ position: 'absolute', left: 10, top: '40%' }}>
        <ArrowBackIos />
      </Button>}

      {images && images.length > 1 && <Button onClick={nextImage} sx={{ position: 'absolute', right: 10, top: '40%' }}>
        <ArrowForwardIos />
      </Button>}

      <Typography variant="h5" sx={{ position: 'absolute', bottom: 10, left: 10 }}>
        {tittle}
      </Typography>

      <IconButton style={{
        position: 'absolute',
        top: '10%',
        left: '90%',
        transform: 'translate(-50%, -50%)',
      }} onClick={handleOpen}>
        <ZoomIn />
      </IconButton>
      {!onlyImages && <IconButton style={{
        position: 'absolute',
        top: '90%',
        left: '90%',
        transform: 'translate(-50%, -50%)',
      }} onClick={handleDownload}>
        <CloudDownloadRounded />
      </IconButton>}
      <Dialog open={open} onClose={handleClose}>
        <DialogContent style={{
          dialogContent: {
            textAlign: 'center',
          }
        }}>
          <img src={images ? resolveImageUrl(images[currentImageIndex]) : BRANDING.logoUrl} alt={`Imagen ${currentImageIndex + 1}`} style={{ maxWidth: '100%', maxHeight: '100%' }} />
        </DialogContent>
      </Dialog>
    </Paper>
  );
}

export default Banner;
